import { render, staticRenderFns } from "./KnTabs.vue?vue&type=template&id=6ef45424&"
import script from "./KnTabs.vue?vue&type=script&lang=js&"
export * from "./KnTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports